/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { FragmentsDeliveryGetDeliveryStatusQueryResponse, FragmentsDeliveryGetDeliveryStatusPathParams, FragmentsDeliveryGetDeliveryStatus401, FragmentsDeliveryGetDeliveryStatus403, FragmentsDeliveryGetDeliveryStatus404 } from "../models/FragmentsDeliveryGetDeliveryStatus";

export function getFragmentsDeliveryGetDeliveryStatusUrl(fragmentId: FragmentsDeliveryGetDeliveryStatusPathParams["fragmentId"]) {
  const res = { method: 'GET', url: `/fragments-delivery/v1/delivery/${fragmentId}` as const }
  return res
}

/**
 * @description Retrieves the current delivery status and progress for a fragment
 * @summary Get delivery status for a fragment
 * {@link /fragments-delivery/v1/delivery/:fragmentId}
 */
export async function fragmentsDeliveryGetDeliveryStatus(fragmentId: FragmentsDeliveryGetDeliveryStatusPathParams["fragmentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FragmentsDeliveryGetDeliveryStatusQueryResponse, ResponseErrorConfig<FragmentsDeliveryGetDeliveryStatus401 | FragmentsDeliveryGetDeliveryStatus403 | FragmentsDeliveryGetDeliveryStatus404>, unknown>({ method : "GET", url : getFragmentsDeliveryGetDeliveryStatusUrl(fragmentId).url.toString(), ... requestConfig })
  return res.data
}